export enum FeatureType {
  Admin = 'Admin',
  CastMeasurements = 'CastMeasurements',
  CreateCharacter = 'CreateCharacter',
  CreateCast = 'CreateCast'
}
